import * as React from "react";
import { RenderCoupon } from "..";

export interface CouponBtnProps {
	coupon: RenderCoupon;
	handleClick: (code: string, index: number) => void;
	index?: number;
}

export const CouponBtn = (props: CouponBtnProps) => {
	const { coupon, index = 0, handleClick } = props;
	const onClick = () => {
		handleClick(coupon?.code, index);
	};
	return <img src={coupon?.img} onClick={onClick} />;
};
